import React, { FC } from 'react';

import './index.scss';

interface StepProps {
  steps: { title: string; active?: boolean }[];
}

const Step: FC<StepProps> = ({ steps }) => (
  <div className="step-container">
    {steps.map((step, index) => (
      <div
        className={`step-item ${step.active ? 'step-item__active' : ''}`}
        key={`step-item-${index}`}
      >
        <div className="step-number">{index + 1}</div>
        <p className="step-title">{step.title}</p>
      </div>
    ))}
  </div>
);

export default Step;
